import React from 'react'
import { observer } from 'mobx-react'
import { FlexContainer, FlexItem } from 'components/Flex'
import { ListItem, ListItemSegment, ListItemTitle } from 'components/ListItem'
import ShadowBox from 'components/ShadowBox'
import ProgressSpinner from 'components/ProgressSpinner'
import Icon from 'components/Icon'
import LinkAccountDialog from 'components/LinkAccountDialog'
import RemoveLinkedAccountDialog from 'components/RemoveLinkedAccountDialog'
import './styles.sass'

const LinkedAccountsManager = ({ manager }) => (
  <div className="linked-accounts-manager">
    <FlexContainer direction="column">
      <FlexItem className="button-container">
        <button className="button is-rounded-outline" onClick={() => manager.showDialog()}>
          <span className="icon">
            <Icon material name="account balance" />
          </span>
          <span>
            Link Account
          </span>
        </button>
      </FlexItem>
      <FlexItem className="linked-accounts">
        {manager.linkedAccounts.length === 0
          ? <EmptyState />
          : manager.linkedAccounts.map((account) =>
            <LinkedAccount
              key={account.id}
              account={account}
              onDeleteClick={() => manager.removeAccount(account)}
              onFixIssuesClick={() => manager.fixIssues(account)}
              removeLinkedAccountDialog={manager.removeLinkedAccountDialog}
            />
          )
        }
      </FlexItem>
    </FlexContainer>

    <LinkAccountDialog dialog={manager.linkAccountDialog} />
    <RemoveLinkedAccountDialog dialog={manager.removeLinkedAccountDialog} account={manager.accountToRemove} />
  </div>
)

export default observer(LinkedAccountsManager)

const EmptyState = () => (
  <div className="content has-text-centered is-medium intro">
    <p>
      Link your financial institutions and Taxfyle will connect
      your tax documents for you.
    </p>
  </div>
)

let LinkedAccount = ({ account, removeLinkedAccountDialog, onDeleteClick, onFixIssuesClick }) => (
  <div className="linked-account">
    <ShadowBox level={4}>
      <ListItem>
        <ListItemSegment pad stretch>
          <ListItemTitle>
            {account.logo
              ? <img src={account.logo} alt={account.institution} className="institution-logo" />
              : account.institution
            }
          </ListItemTitle>
        </ListItemSegment>
        {account.syncing &&
          <ListItemSegment pad>
            <ProgressSpinner color="#2395F3" />
          </ListItemSegment>
        }
        {account.needsUserInteraction &&
          <ListItemSegment pad>
            <button className="button is-danger" onClick={onFixIssuesClick}>
              <span className="icon">
                <Icon material name="error outline" />
              </span>
              <span>
                Fix Issues
              </span>
            </button>
          </ListItemSegment>
        }
        <ListItemSegment pad>
          <button className="button is-icon-only" onClick={() => onDeleteClick()}>
            <Icon material name="delete" />
          </button>
        </ListItemSegment>
      </ListItem>
    </ShadowBox>
  </div>
)

LinkedAccount = observer(LinkedAccount)



// WEBPACK FOOTER //
// ./src/client/components/LinkedAccountsManager/index.jsx